import {Label} from '@hm/fundamental'
import {useTranslation} from 'react-i18next'

export const ShutdownHistoryLabel: React.FC = () => {
  const {t} = useTranslation()
  return (
    <Label
      title={''}
      data-cy="shutdown_history_card_label"
      {...{children: t('staticParts.shutdownHistory.title')}}
      inverted
    />
  )
}
